import React, { useState } from 'react';
import { FiUpload, FiDownload, FiFile } from 'react-icons/fi';

const BulkUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState('idle');

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = () => {
    if (!selectedFile) return;
    
    setUploadStatus('uploading');
    setUploadProgress(0);
    
    // Simulate upload progress
    const interval = setInterval(() => {
      setUploadProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setUploadStatus('completed');
          return 100;
        }
        return prev + 10;
      });
    }, 300);
  };

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-800">Bulk Product Upload</h2>
        <p className="text-sm text-gray-500">Upload multiple products via CSV file</p>
      </div>
      
      <div className="px-6 py-6">
        <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
          <FiUpload className="mx-auto h-12 w-12 text-gray-400" />
          <h3 className="mt-2 text-sm font-medium text-gray-900">Upload your products CSV file</h3>
          <p className="mt-1 text-sm text-gray-500">File should include product details in the correct format</p>
          
          <div className="mt-6">
            <label className="inline-flex items-center px-4 py-2 bg-indigo-600 text-white rounded-md shadow-sm hover:bg-indigo-700 cursor-pointer">
              <FiFile className="mr-2" />
              Select CSV File
              <input
                type="file"
                accept=".csv"
                onChange={handleFileChange}
                className="sr-only"
              />
            </label>
            {selectedFile && (
              <p className="mt-2 text-sm text-gray-500">{selectedFile.name}</p>
            )}
          </div>
        </div>
        
        {uploadStatus !== 'idle' && (
          <div className="mt-6">
            <div className="flex justify-between mb-1">
              <span className="text-sm font-medium text-gray-700">
                {uploadStatus === 'uploading' ? 'Uploading...' : 'Upload Complete'}
              </span>
              <span className="text-sm font-medium text-gray-500">{uploadProgress}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5">
              <div
                className="bg-indigo-600 h-2.5 rounded-full"
                style={{ width: `${uploadProgress}%` }}
              ></div>
            </div>
          </div>
        )}
        
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-blue-50 p-4 rounded-lg">
            <h3 className="text-sm font-medium text-blue-800">Download Template</h3>
            <p className="mt-1 text-sm text-blue-600">
              Use our template to ensure proper formatting
            </p>
            <button className="mt-3 inline-flex items-center px-3 py-1 border border-blue-300 text-sm font-medium rounded-md text-blue-700 bg-white hover:bg-blue-50">
              <FiDownload className="mr-2" />
              Download CSV Template
            </button>
          </div>
          
          <div className="bg-yellow-50 p-4 rounded-lg">
            <h3 className="text-sm font-medium text-yellow-800">Instructions</h3>
            <ul className="mt-1 text-sm text-yellow-700 list-disc pl-5">
              <li>Include all required fields</li>
              <li>Maintain column order</li>
              <li>Max file size: 5MB</li>
            </ul>
          </div>
        </div>
        
        <div className="mt-6 flex justify-end">
          <button
            onClick={handleUpload}
            disabled={!selectedFile || uploadStatus === 'uploading'}
            className={`px-4 py-2 rounded-md shadow-sm text-sm font-medium text-white ${
              !selectedFile || uploadStatus === 'uploading'
                ? 'bg-indigo-300 cursor-not-allowed'
                : 'bg-indigo-600 hover:bg-indigo-700'
            }`}
          >
            {uploadStatus === 'uploading' ? 'Processing...' : 'Upload Products'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkUpload;